import { memo } from "react";
import Box from "@mui/material/Box";

import InfiniteScrollWrapper from "../../../../common/components/infinite-scroll/InfiniteScrollWrapper";
import FullPageLoader from "../../../../common/components/item/FullPageLoader";
import { useCustomerIdGuard } from "../../../../common/hooks/useCustomerIdGuard";
import { useSelectedLocation } from "../../../../common/variables/selectedLocation";
import { useSelectedModel } from "../../../../common/variables/selectedModel";
import BasicEventTable from "./BasicEventTable";
import GasLeakEventTable from "./GasLeakEventTable";
import { useGetRecentEvents } from "../../hooks/events/useGetRecentEvents";

const EventTableContainer = (): JSX.Element => {
  const customerId = useCustomerIdGuard();
  const modelId = useSelectedModel();
  const facilityId = useSelectedLocation();

  const { events, loading, fetchNextPage, lastEvaluatedKey } =
    useGetRecentEvents({
      customerId,
      modelId: modelId ?? "",
      facilityId: facilityId ?? "",
    });

  if (loading) return <FullPageLoader />;

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <InfiniteScrollWrapper
        fetchNextPage={fetchNextPage}
        lastEvaluatedKey={lastEvaluatedKey}
        loading={loading}
      >
        {events.map(({ event, newestRecording }) => {
          switch (event.modelId) {
            case "GASLEAK":
              return (
                <GasLeakEventTable
                  event={event}
                  newestRecording={newestRecording}
                  key={event.id}
                />
              );
            default:
              return (
                <BasicEventTable
                  event={event}
                  newestRecording={newestRecording}
                  key={event.id}
                />
              );
          }
        })}
      </InfiniteScrollWrapper>
    </Box>
  );
};

export default memo(EventTableContainer);
